import { useAppState } from '../useAppState';

export const useBookingReservationEditorState = () => {
  const { bookingReservationEditorState } = useAppState();

  return bookingReservationEditorState;
};
